import {initCartSummary} from './init-cart-summary';

const initCheckoutSummary = () => {
  const checkout = document.querySelector('form.woocommerce-checkout');

  if (!checkout) {
    return;
  }

  jQuery(document.body).on('updated_checkout', () => {
    initCartSummary();
  });
};

export {initCheckoutSummary};
